import { Input, Popover, stopPropagation } from "@overmap-ai/blocks"
import { type ChangeEventHandler, type ComponentPropsWithoutRef, memo, useCallback, useEffect, useState } from "react"

interface TextInputPopoverProps
	extends ComponentPropsWithoutRef<typeof Popover.Root>, ComponentPropsWithoutRef<typeof Popover.Content> {
	placeholder?: string
	value?: string
	onValueChange?: (value: string) => void
}

export const TextInputPopover = memo<TextInputPopoverProps>((props) => {
	const {
		children,
		open,
		onOpenChange,
		defaultOpen,
		modal,
		size,
		accentColor = "base",
		value: controlledValue,
		onValueChange,
		placeholder = "Enter text",
		...rest
	} = props

	const [value, setValue] = useState("")

	const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>((e) => {
		setValue(e.target.value)
	}, [])

	const handleBlur = useCallback<ChangeEventHandler<HTMLInputElement>>(
		(e) => {
			const value = e.target.value

			onValueChange?.(value)
		},
		[onValueChange],
	)

	useEffect(() => {
		if (controlledValue) setValue(controlledValue)
	}, [controlledValue])

	return (
		<Popover.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen} modal={modal}>
			<Popover.Trigger asChild>{children}</Popover.Trigger>
			<Popover.Content size={size} onClick={stopPropagation} {...rest}>
				<Input.Root size={size} accentColor={accentColor}>
					<Input.Field
						placeholder={placeholder}
						type="text"
						value={value}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</Input.Root>
			</Popover.Content>
		</Popover.Root>
	)
})
TextInputPopover.displayName = "TextInputPopover"
